// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c52af6db","605":"0f54fb9d","809":"62452d41","981":"fcf1ae50"}[chunkId] + ".chunk.js";
};